module.exports = __webpack_public_path__ + "img/Number=8.6fe24461.png";